import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingTg: false,
  loadingWa: false,
  loadingInst: false,

  updateDataTg: null,
  updateDataWa: null,
  updateDataInst: null,

  errorTg: false,
  errorWa: false,
  errorBitrix: false,
  errorInst: false,

  dataBots: localStorage.getItem("dataBots")
    ? JSON.parse(localStorage.getItem("dataBots"))
    : null,
  newBot: null,
  activeBot: localStorage.getItem("activeBot")
    ? JSON.parse(localStorage.getItem("activeBot"))
    : null,
  updateBot: false,
  updateDataBot: null,
  telegramBotUsers: null,
  userData: null,

  dataTg: null,
  newTg: null,
  activeTg: localStorage.getItem("dataTg")
    ? JSON.parse(localStorage.getItem("dataTg"))
    : null,
  updateTg: false,

  dataWa: null,
  newWa: null,
  activeWa: localStorage.getItem("dataWa")
    ? JSON.parse(localStorage.getItem("dataWa"))
    : null,
  updateWa: false,

  dataBitrix: localStorage.getItem("dataBitrix")
    ? JSON.parse(localStorage.getItem("dataBitrix"))
    : null,
  newBitrix: null,
  activeBitrix: localStorage.getItem("activeBitrix")
    ? JSON.parse(localStorage.getItem("activeBitrix"))
    : null,
  updateBitrix: false,
  updateDataBitrix: null,

  outdatedCode: false,

  dataInst: null,
  newInst: null,
  activeInst: localStorage.getItem("dataInst")
    ? JSON.parse(localStorage.getItem("dataInst"))
    : null,
  updateInst: false,
};

const integrationSlice = createSlice({
  name: "integration",
  initialState,
  reducers: {
    setLoadingTg(state, action) {
      state.loadingTg = action.payload;
    },
    setLoadingWa(state, action) {
      state.loadingWa = action.payload;
    },
    setLoadingInst(state, action) {
      state.loadingInst = action.payload;
    },
    setUpdateDataTg(state, action) {
      state.updateDataTg = action.payload;
    },
    setUpdateDataWa(state, action) {
      state.updateDataWa = action.payload;
    },
    setUpdateDataInst(state, action) {
      state.updateDataInst = action.payload;
    },

    setErrorTg(state, action) {
      state.errorTg = action.payload;
    },
    setErrorWa(state, action) {
      state.errorWa = action.payload;
    },
    setErrorBitrix(state, action) {
      state.errorBitrix = action.payload;
    },
    setErrorInst(state, action) {
      state.errorInst = action.payload;
    },

    setDataBots(state, action) {
      state.dataBots = action.payload;
    },
    setNewBot(state, action) {
      state.newBot = action.payload;
    },
    setActiveBot(state, action) {
      state.activeBot = action.payload;
    },
    setUpdateBot(state, action) {
      state.updateBot = action.payload;
    },
    setUpdateDataBot(state, action) {
      state.updateDataBot = action.payload;
    },
    setTelegramBotUsers(state, action) {
      state.telegramBotUsers = action.payload;
    },
    setUserData(state, action) {
      state.userData = action.payload;
    },

    setDataTg(state, action) {
      state.dataTg = action.payload;
    },
    setNewTg(state, action) {
      state.newTg = action.payload;
    },
    setActiveTg(state, action) {
      state.activeTg = action.payload;
    },
    setUpdateTg(state, action) {
      state.updateTg = action.payload;
    },

    setDataWa(state, action) {
      state.dataWa = action.payload;
    },
    setNewWa(state, action) {
      state.newWa = action.payload;
    },
    setActiveWa(state, action) {
      state.activeWa = action.payload;
    },
    setUpdateWa(state, action) {
      state.updateWa = action.payload;
    },

    setDataInst(state, action) {
      state.dataInst = action.payload;
    },
    setNewInst(state, action) {
      state.newInst = action.payload;
    },
    setActiveInst(state, action) {
      state.activeInst = action.payload;
    },
    setUpdateInst(state, action) {
      state.updateInst = action.payload;
    },

    setDataBitrix(state, action) {
      state.dataBitrix = action.payload;
    },
    setNewBitrix(state, action) {
      state.newBitrix = action.payload;
    },
    setActiveBitrix(state, action) {
      state.activeBitrix = action.payload;
    },
    setUpdateBitrix(state, action) {
      state.updateBitrix = action.payload;
    },
    setUpdateDataBitrix(state, action) {
      state.updateDataBitrix = action.payload;
    },

    setOutdatedCode(state, action) {
      state.outdatedCode = action.payload;
    },
  },
});

export const {
  setLoadingTg,
  setLoadingWa,
  setErrorTg,
  setErrorWa,
  setErrorBitrix,
  setErrorInst,
  setLoadingInst,
  setUpdateDataTg,
  setUpdateDataWa,
  setUpdateDataInst,
  setDataBots,
  setNewBot,
  setActiveBot,
  setUpdateBot,
  setUpdateDataBot,
  setTelegramBotUsers,
  setUserData,
  setDataTg,
  setNewTg,
  setActiveTg,
  setUpdateTg,
  setDataWa,
  setNewWa,
  setActiveWa,
  setUpdateWa,
  setDataInst,
  setNewInst,
  setActiveInst,
  setUpdateInst,
  setDataBitrix,
  setNewBitrix,
  setActiveBitrix,
  setUpdateBitrix,
  setUpdateDataBitrix,
  setOutdatedCode,
} = integrationSlice.actions;

export default integrationSlice.reducer;
